module.exports = __webpack_public_path__ + "img/alarm1.091d629e.svg";